/*
    F: 15-APR-2026 
    E: 01-APR-2026 
    D: 15-MAR-2026 
    C: 01-MAR-2026 
    B: 15-FEB-2026 
    A: 01-FEB-2026 
*/
export const periodHBA = {
    F: { HBA0: 103.43, HBA1: 77.71, HBA2: 52.84, HBA3: 38.3  },
    E: { HBA0: 99.87,  HBA1: 72.28, HBA2: 49.99, HBA3: 35.23 },
    D: { HBA0: 103.01, HBA1: 71.55, HBA2: 48.32, HBA3: 34.25 },
    C: { HBA0: 102.37, HBA1: 71.29, HBA2: 47.64, HBA3: 34.25 },
    B: { HBA0: 102.87, HBA1: 71.74, HBA2: 47.34, HBA3: 33.85 },
    A: { HBA0: 106.11, HBA1: 73.96, HBA2: 48.21, HBA3: 35.83 }
};